  export const distanceParser = (distance: string): string => {
  const number = parseFloat(distance);

  return isNaN(number)
    ?   '0'
    :  number.toFixed(2).replace('.00', '')
};